import getAllCookie from "./getAllCookie";

export default function getCookie(name) {
  const allCookie = getAllCookie();
  const findCookie = allCookie.find((cookie) => cookie.key === name);

  return findCookie;
}
